import React, { Dispatch, useEffect, useState } from "react";
import { 
    Typography, 
    Card, 
    // CardActions, 
    CardContent, 
    // Button, 
    Collapse 
} from "@mui/material";
// import EditFaq from "../components/EditFaq";
import { StyledContainer } from "../StyledComponents";
import { useTranslation } from "react-i18next";
// import { Faq } from "../types/Faq"

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function FaqPage(props: { setTitle: Dispatch<React.SetStateAction<string>>}) {

    const { t } = useTranslation();

    // const blankFaq: Faq = {
    //     id: "",
    //     question: "",
    //     answer: ""
    // }

    // const [isEditFaqOpen, setIsEditFaqOpen] = useState<boolean>(false)
    // const [isEdit, setIsEdit] = useState<boolean>(false)
    // const [faqContent, setFaqContent] = useState<Faq>(blankFaq)

    // const closeEditFaq = () => {
    //     setFaqContent(blankFaq)
    //     setIsEditFaqOpen(false);
    // }

    // const handleAddFaq = () => {
    //     setIsEditFaqOpen(true)
    //     setIsEdit(false)
    //     setFaqContent(blankFaq)
    // }

    // const handleEditFaq = (content: Faq, edit: boolean) => {
    //     setIsEditFaqOpen(true)
    //     setIsEdit(edit)
    //     setFaqContent(content)
    // }

    // const convertToFaq = (id: string, question: string, answer: string, edit: boolean) => {
    //     const oldFaq: Faq = {
    //         id: id,
    //         question: question,
    //         answer: answer
    //     }
    //     handleEditFaq(oldFaq, edit)
    // }

    useEffect(() => {
        props.setTitle("faq");
    }, [])

    return (
        <div>
            <StyledContainer style={{ paddingTop: 90, paddingBottom: 80 }}>
                <Typography variant="h5" component="h2">
                    {/* <Button color="primary" variant="contained" onClick={() => handleEditFaq(blankFaq, false)}>
                        {t("faq.add_new_faq")}
                    </Button> */}
                    {Object.values(t("faq.faq", {returnObjects: true})).map((item, index) =>
                        <>
                            <Card sx={{ minWidth: 500}} variant="outlined" style={{ marginBottom: 5 }}>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        {(index+1)+". "+item.question}
                                    </Typography>
                                    <Typography variant="body2" style={{ marginLeft: 25 }}>
                                        {item.answer}<br />
                                        {item.link !== "" && <a href={item.link}>{item.words_for_link}</a>}
                                    </Typography>
                                </CardContent>
                                {/* <CardActions style={{ justifyContent: "right" }}>
                                    <Button size="small" onClick={() => convertToFaq(item.id, item.question, item.answer, true)}><EditIcon />{t("butt.edit")}</Button>
                                    <Button size="small"><DeleteIcon />{t("butt.delete")}</Button>
                                </CardActions> */}
                            </Card>
                        </>
                    )}
                </Typography>
            </StyledContainer>
            {/* <EditFaq isOpen={isEditFaqOpen} onClose={closeEditFaq} faqContent={faqContent} isEdit={isEdit} /> */}
        </div>
    )
}